<template>
  <!-- header-start -->
  <header>
    <div class="header-area">
      <div id="sticky-header" class="main-header-area">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-xl-2 col-lg-2">
              <div class="logo">
                <router-link to="/">
                  <img src="@/assets/img/logo.png" alt style="height:40px"/>
                </router-link>
              </div>
            </div>
            <div class="col-xl-5 col-lg-5"></div>
            <div class="col-xl-4 col-lg-4">
              <div class="main-menu d-none d-lg-block">
                <nav>
                  <ul id="navigation">
                    <li>
                      <router-link to="/" class="active">Home</router-link>
                    </li>
                    <li>
                      <router-link to="/features">Features</router-link>
                    </li>
                    <li>
                      <router-link to="/contact">Contact</router-link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="col-xl-1 col-lg-1 d-none d-lg-block">
              <div class="Appointment">
                <div class="book_btn d-none d-lg-block">
                  <a href="#">Download</a>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mobile_menu d-block d-lg-none"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <!-- header-end -->
</template>
<script>
export default {};
</script>
<style scoped>
</style>